/*
https://wicg.github.io/netinfo/#dfn-effective-connection-type
https://caniuse.com/#feat=netinfo
VERY limited support of this, but we can detect the connection speed of the users browser

 */
function fnConnectionSpeedClasses(){
	var sConnectionType = "connection-type-4g";
	if (typeof navigator.connection !== 'undefined') {
		
		var oNavigator = navigator.connection;
		if (typeof oNavigator.effectiveType !== 'undefined') {
			
			/*
			VALUES
				slow-2g
				2g
				3g
				4g
			 */
			$('body').addClass('connection-type-'+oNavigator.effectiveType);
		}else{
			$('body').addClass(sConnectionType);
		}
	}else{
		$('body').addClass(sConnectionType);
	}

}